const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;
const UNITS_KEY = 'ASSIGNMENT_POLICY.REDESIGN.UNITS';

// Formats a duration expressed in minutes using the largest exact unit.
export const formatDurationMinutes = (minutes, t) => {
  const value = Number(minutes);
  if (!Number.isFinite(value) || value <= 0) return '';
  if (value % MINUTES_PER_DAY === 0) {
    const days = value / MINUTES_PER_DAY;
    return t(`${UNITS_KEY}.DAYS`, { n: days }, days);
  }
  if (value % MINUTES_PER_HOUR === 0) {
    return t(`${UNITS_KEY}.HOURS`, { n: value / MINUTES_PER_HOUR });
  }
  return t(`${UNITS_KEY}.MINUTES`, { n: value });
};

const normalize = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

// Client-side search over the already loaded policies (name/description).
export const filterPolicies = (policies, query) => {
  const term = normalize(query);
  if (!term) return policies;
  return policies.filter(policy =>
    [policy.name, policy.description].some(field =>
      normalize(field).includes(term)
    )
  );
};
